import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => () => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="topp"
      className="relative pt-36 pb-20 md:pt-44 md:pb-28 overflow-hidden"
      data-testid="hero-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto text-center fade-up">
          <span
            className="inline-flex items-center gap-2 rounded-full border border-black/10 bg-white px-3 py-1 text-xs font-medium text-[#1D1D1F]/70"
            data-testid="hero-badge"
          >
            <span className="h-1.5 w-1.5 rounded-full bg-[#1D1D1F]" />
            Postordre-reparasjon i hele Norge
          </span>

          <h1
            className="font-display mt-6 text-5xl sm:text-6xl md:text-7xl font-semibold tracking-tighter leading-[1.02] text-[#1D1D1F]"
            data-testid="hero-heading"
          >
            Ekspertise på Apple.
            <br />
            <span className="text-[#86868B]">Rett i postkassen.</span>
          </h1>

          <p
            className="mt-7 text-lg md:text-xl text-[#1D1D1F]/70 leading-relaxed max-w-2xl mx-auto"
            data-testid="hero-subtitle"
          >
            Vi reparerer iPhone, iPad, MacBook og iMac — alt via post. Send inn
            enheten, så får du den trygt tilbake, klar til bruk.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Button
              onClick={scrollTo("kontakt")}
              className="rounded-full bg-[#1D1D1F] hover:bg-[#0a0a0a] text-white px-7 h-12 text-base font-medium"
              data-testid="hero-cta-primary"
            >
              Start reparasjon
              <ArrowRight size={18} strokeWidth={1.75} className="ml-1" />
            </Button>
            <Button
              variant="ghost"
              onClick={scrollTo("slik-fungerer-det")}
              className="rounded-full text-[#1D1D1F] hover:bg-black/5 px-6 h-12 text-base font-medium"
              data-testid="hero-cta-secondary"
            >
              Slik fungerer det
            </Button>
          </div>
        </div>

        {/* Visual band */}
        <div className="mt-20 md:mt-24 fade-up" style={{ animationDelay: "120ms" }}>
          <div className="relative rounded-3xl overflow-hidden bg-[#F5F5F7] border border-black/[0.04]">
            <img
              src="https://images.pexels.com/photos/3945698/pexels-photo-3945698.jpeg"
              alt="Minimalistisk oppstilling av Apple-enheter"
              className="w-full h-[320px] sm:h-[420px] md:h-[520px] object-cover"
              loading="lazy"
              data-testid="hero-image"
            />
          </div>
          <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-6 text-left">
            {[
              { k: "Spesialiserte", v: "Kun Apple-produkter" },
              { k: "Postordre", v: "Hele Norge" },
              { k: "Trygt", v: "Sporet retur" },
              { k: "Erfaring", v: "Sertifiserte teknikere" },
            ].map((m) => (
              <div key={m.k} className="border-t border-black/10 pt-4">
                <div className="text-xs uppercase tracking-wider text-[#86868B]">{m.k}</div>
                <div className="mt-1 text-sm font-medium text-[#1D1D1F]">{m.v}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
